<template>
  <llp-page
    id="datatable-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <!-- Status Cards -->
        <div class="card m-2 m-lg-3">
          <div class="card-body">
            <div class="row d-flex align-items-center rental-payment mb-4">
              <div class="col mt-4">
                <h4 class="rental-heading">Support</h4>
              </div>
              <div class="col d-flex justify-content-end" v-if="login_user_role !== '1'">
                <llp-button
                  :load-spinner="showaddUserSpinner"
                  classNames="btn-secondary new-btn"
                  type="button"
                  @click="addNewComplaint"
                >
                  Create Ticket
                </llp-button>
              </div>
            </div>

            <div class="row">
              <div
                class="col-lg-3 col-md-4 col-sm-6 mb-4"
                v-for="status in statusOptions"
                :key="status.value"
              >
                <div
                  class="card card-with-shadow"
                  :class="{ 'active-card': selectedStatus === status.value }"
                >
                  <div class="card-body" @click="fetchTabData(status.value)">
                    <h6 class="fs-5 ms-2">{{ status.label }}</h6>
                    <div class="d-flex align-items-center">
                      <i class="ri-emotion-line fs-6 text-muted"></i>
                      <p class="fs-6 mb-0 ms-2">{{ status.description }}:</p>
                      <h1 class="fw-bold ms-auto text-end fs-6">
                        {{ getCount(status.value) }}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Search & Table -->
        <div class="card m-2 m-lg-3">
          <div class="row m-4 align-items-center">
            <div class="col-lg-3 col-md-4 col-sm-6 mt-4">
              <llp-label id="username-label" class="col-form-label">
                Ticket/Status:
              </llp-label>
              <llp-input
                id="username"
                class="search-by-names"
                v-model="searchValue"
                autocomplete="off"
                :placeHolder="`Enter searched value...`"
              />
            </div>
          </div>

          <div class="tab-content m-4 position-relative">
             <div v-if="loading" class="loader-overlay">
            <div class="spinner"></div>
                    </div>
            <llp-datatable
              ref="usersTable"
              :columns="completedColumns"
              :data="TicketsData"
              :lazy="true"
              :paginator="true"
              :totalRecords="totalRecords"
              scrollable
              @onPageChange="onPageChange"
            >
             <template #attachments="{ data }">
            <div class="text-center">
              <a
                v-if="data.attachment && data.attachment !== 'No attachment available'"
                :href="data.attachment" 
                target="_blank" 
              >
                <img
                  :src="data.attachment"
                  alt="attachment"
                  class="img-fluid"
                  style="max-width: 100px; height: auto"
                />
              </a>
              <span v-else>No attachment available</span>
            </div>
          </template>
              <template #actions="{ data }">
                <div class="text-center">
                  <button
                    class="btn btn-secondary transparent-btn"
                    @click="EditTicket(data.id)"
                  >
                    <i class="fa fa-eye fs-4"></i>
                  </button>
                </div>
              </template>

              <template #status="{ data }">
                <div class="text-center">
                  <p
                    class="fs-6 mb-0 ms-2 f-w-400 ticket_status"
                    :class="{
                      'status-open': data.status === 'Open',
                      'status-closed': data.status === 'Closed',
                      'status-pending': data.status === 'Processing',
                    }"
                  >
                    {{ data.status }}
                  </p>
                </div>
              </template>
            </llp-datatable>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
   <llp-toast ref="toast"></llp-toast>

</template>



<script>
import NetworkService from "@/services/network.service";
// import ErrorService from "@/services/error.service";

export default {
  data() {
    return {
      loading:true,
      selectedStatus: "All",
      searchValue: "",
      supportData: [],
      totalTickets: 0,
      openTicketCount: 0,
      onHoldTicketCount: 0,
      closedTicketCount: 0,
      totalRecords: 0,
      currentPage: 1,
      perpage: 10,
      showaddUserSpinner: false,
      login_user_role:localStorage.getItem('role_id'),
      completedColumns: [
        { field: "date", className: "text-center", header: "Date" },
        { field: "createBy", className: "text-center", header: "Created By" },
        { field: "subject", className: "text-center", header: "Subject" },
        { field: "ticket", className: "text-center", header: "Ticket Number" },
        {
          field: "status",
          header: "Status",
          className: "text-center",
          isCustomized: true,
          customizeName: "status",
        },
        {
            header: 'Attachment',
            field: 'attachment',
            sortable: false,
            className: 'text-center',
            isCustomized: true,
            customizeName: 'attachments',
        },
        {
          header: "Action",
          field: "action",
          sortable: false,
          className: "text-center",
          isCustomized: true,
          customizeName: "actions",
        },
      ],
      statusOptions: [
        { value: "All", label: "Total", description: "Total Tickets" },
        { value: "Open", label: "Open", description: "Open Tickets" },
        {
          value: "Processing",
          label: "Processing",
          description: "Processing Tickets",
        },
        { value: "Closed", label: "Closed", description: "Closed Tickets" },
      ],
    };
  },

  computed: {
    TicketsData() {
      let filtered = this.supportData;

      if (this.selectedStatus !== "All") {
        filtered = filtered.filter(
          (ticket) => ticket.status === this.selectedStatus
        );
      }

      if (this.searchValue.trim()) {
        const search = this.searchValue.toLowerCase();
        filtered = filtered.filter(
          (ticket) =>
            ticket.ticket.toLowerCase().includes(search) ||
            ticket.createBy.toLowerCase().includes(search) ||
            ticket.status.toLowerCase().includes(search)
        );
      }

      return filtered;
    },
  },

  created() {
    this.fetchTabData("All");
  },

  methods: {
    addNewComplaint() {
      this.$router.push({ name: "CreateTicket" });
    },

    EditTicket(id) {
      this.$router.push({ name: "EditTicket", params: { id } });
    },

    onPageChange({ page }) {
      this.currentPage = page + 1;
      this.fetchTabData(this.selectedStatus);
    },

    getCount(status) {
      switch (status) {
        case "Open":
          return this.openTicketCount;
        case "Processing":
          return this.onHoldTicketCount;
        case "Closed":
          return this.closedTicketCount;
        case "All":
        default:
          return this.totalTickets;
      }
    },


    async fetchTabData(status) {
  this.selectedStatus = status;
  try {
    const params = {
      page: this.currentPage,
      per_page: this.perpage,
    };
    if (status !== "All") {
      params.status = status === "Processing" ? "On Hold" : status;
    }
    const response = await NetworkService.get(`/support-tickets`, params);
    const tickets = response.data.tickets || [];
    this.supportData = tickets.map((ticket) => ({
      id: ticket.id,
      date: ticket.created_on,
      createBy: ticket.user?.username || "N/A",
      subject: ticket.subject || "N/A",
      ticket: ticket.ticket_no || "N/A",
      status: ticket.status === "On Hold" ? "Processing" : ticket.status || "Open",
      attachment: ticket.attachment
            ? `${ticket.attachment}`
            : "No attachment available",
    }));
    this.totalTickets = response.data.total_tickets || 0;
    this.openTicketCount = response.data.open_tickets || 0;
    this.onHoldTicketCount = response.data.on_hold_tickets || 0;
    this.closedTicketCount = response.data.closed_tickets || 0;
    this.totalRecords = response.data.total_tickets || 0;
    this.loading = false;
  } catch (error) {
    this.loading = false;
    this.$refs.toast.show("No tickets", "error");
  }
}
  },
};
</script>


